import React, { useEffect, useContext, useState, useCallback } from 'react'
import { StandingsContext, SeasonContext } from '../../Context'
import { Box, PageContainerMain } from '../../Components/Layout'
import { Spinner } from '../../Components/Icons'
import { colors } from '../../Components/consts'
import { createStandingsDynamicLink } from '../../Utils/DynamicLinks/dynamicLinkHelpers'
import { BottomAppCallout } from '../../Components/Layout/Overlays'
import { PageHeader } from '../../Components/Headers'
import { SeasonSelector } from '../../Components/Layout/Selectors/Year/SeasonSelector'
import { HeadXL } from '../../Components/Typography/Text.styles'
import { InnerCon } from './styles'
import { AdUnit } from '../../Components/Ads/AdUnit'
import { StandingsOuter } from '../../Components/Standings/StandingsOuter'
import { SEASON_SELECTOR_TYPES } from '../../Constants/season'
import { SEASON_SEGMENT_NAMES } from '../../Utils'
import { TeamStanding } from '../../Api'

const Standings: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { seasonSelect } = useContext(SeasonContext)!
  const { standings, banner, loading } = useContext(StandingsContext)!
  const [standingsData, setStandingsData] = useState<TeamStanding[]>([])
  const appDynamicLink = createStandingsDynamicLink(true)
  const selectType = SEASON_SELECTOR_TYPES.STANDINGS
  const getStandingsTitle = useCallback(() => {
    if (seasonSelect[selectType].seasonType === SEASON_SEGMENT_NAMES.regular) {
      return `${seasonSelect[selectType].year} Regular Season Standings`
    }
    if (seasonSelect[selectType].seasonType === SEASON_SEGMENT_NAMES.post) {
      return `${seasonSelect[selectType].year} Postseason Standings`
    }
    if (seasonSelect[selectType].seasonType === SEASON_SEGMENT_NAMES.champseries) {
      return 'Championship Series Standings'
    }
    return 'Standings'
  }, [standings])

  useEffect(() => {
    setStandingsData(standings)
  }, [standings])

  return (
    <>
      <PageContainerMain>
        {banner && !banner.sponsor && (
          <PageHeader banner={banner} img={banner.topUrl} link={banner.topLink} />
        )}
        <AdUnit bannerType="bannerMain" aria-label="Standings page ad" />
        <Box noMargin>
          <InnerCon>
            <HeadXL sideMargins={2} className="header">
              {getStandingsTitle()}
            </HeadXL>
            <SeasonSelector seasonSelectorType={SEASON_SELECTOR_TYPES.STANDINGS} />
            <div className="standingsCon">
              {loading && (
                <div>
                  <Spinner fill={colors.yellow} width={50} />
                  Loading...
                </div>
              )}
              {!loading && standingsData.length > 0 && (
                <>
                  <StandingsOuter
                    items={standingsData}
                    full
                    seasonSelect={seasonSelect[selectType]}
                    section={'standings_page'}
                  />
                  <div className="footerInfo">
                    <p>{`**Score Differential is first tiebreaker. `}</p>
                    <p>
                      <strong>S:</strong> {` Scores `}
                    </p>
                    <p>
                      <strong>SA:</strong> {` Scores Against `}
                    </p>
                    <p>
                      <strong>SD:</strong> {` Score Differential `}
                    </p>
                  </div>
                </>
              )}
            </div>
            <AdUnit bottomFixed bannerType="bannerSecond" aria-label="Standings page ad second" />
          </InnerCon>
        </Box>
      </PageContainerMain>
      <BottomAppCallout appLink={appDynamicLink} location="Standings_Page" />
    </>
  )
}

export default Standings
